import { IProject } from './../projects.interface';
import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ProjectsHttpService } from '../projects-http.service';
import { ProjectsService } from '../projects.service';
import { Observable, debounceTime, distinctUntilChanged, of, startWith, switchMap } from 'rxjs';
import { getEmptyDetailItemExpense, IExpense } from '../../../expenses-page/expenses/expenses.interface';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';
import { AlertService } from '../../../../shared/services/alert.service';

let self: any;

@Component({
  selector: 'app-projects-modal',
  templateUrl: './projects-modal.component.html',
  styleUrls: ['./projects-modal.component.css']
})
export class ProjectsModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  showEdit: boolean = true;
  loading: boolean = false;
  saving: boolean = false;
  project: IProject =  {
    serieAndNumber: '',
    client: '',
    name: '',
    description: '',
    startDate: undefined,
    endDate: undefined,
    status: '',
    location: '',
    coordinatesType: '',
    coordinates: [],
    stakeholders: [],
    manager: '',
    expenses: [],
    totalExpenses: 0,
  };
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  action!: string;

  // clients
  $clients: Observable<any> = of();
  clientsTerm: string = '';

  emptyItemExpense = getEmptyDetailItemExpense();

  constructor(
    private _ProjectsHttpService: ProjectsHttpService,
    private _ProjectsService: ProjectsService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    public _ClientsService: ClientsService,
    private _AlertService: AlertService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  async ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    if (!Array.isArray(this.project.expenses) || this.project.expenses.length === 0) {
      this.project.expenses = [getEmptyDetailItemExpense()];
    }
    if (this.project._id) {
      this.action = "Modificar"
      await this.getProject();
    } else {
      this.action = "Crear"
      await this.buildForm();
    }
    console.log(this.readOnly)
  }

  async getProject() {
    this.loading = true;
    await this._ProjectsHttpService.getProject(this.project._id).subscribe((project) => {
      console.log(project)
      this.project = project;
      if (!Array.isArray(this.project.expenses) || this.project.expenses.length === 0) {
        this.project.expenses = [getEmptyDetailItemExpense()];
      }
      this.buildForm();
    });
  }

  get f() { return this.form.controls; }
  async buildForm() {
    const today = new Date(); // Fecha actual
    const defaultStartDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    const defaultEndDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate(), 0, 0, 0);
  
    const startDate = this.project?.startDate 
      ? new Date(this.project.startDate).toISOString().substring(0, 10) 
      : defaultStartDate.toISOString().substring(0, 10);
  
    const endDate = this.project?.endDate 
      ? new Date(this.project.endDate).toISOString().substring(0, 10) 
      : defaultEndDate.toISOString().substring(0, 10);

    this.form = this.fb.group({
      client: [this.project?.client, Validators.compose([Validators.required, clientValidator])],
      name: [this.project.name],
      description: [this.project.description || ''],
      startDate: [startDate],
      endDate: [endDate],
      expenses: [this.project.expenses || null],
      totalExpenses: [this.project.totalExpenses || 0],
    })

    this.$clients = this.f['client'].valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          this.clientsTerm = val;
          return this.filterClients(val || '')
        })
      );

    this.loading = false;
  }

  filterClients(val: string): Observable<any[]> {

    if (typeof val === 'string') {
      return this._ClientsService.getClients({
        sort: 'firstname lastname',
        skip: 0,
        limit: 5000,
        filters: { client: val, isDeleted: false },
        company: this._AuthService.companyId()
      });
    } else {
      return new Observable<any[]>;
    }
  }

  onClientSelectionChange() {
    console.log(this.form.get('client'))
    this.form.get('client')?.setErrors({ 'notToBilling': null });
  }

  displayClientsFn(client: IClient): string {
    if (client) {
      const firstName = client.firstname?.trim();
      const lastName = client.lastname ? " " + client.lastname.trim() : '';
      return firstName + lastName;
    } else {
      return '';
    }
  }

  openNewClientModal() {
    this.openClientModal({});
  }

  openClientModal(client: IClient) {
    //console.log(client)
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.clientDialogRef = this._dialog.open(ClientsModalComponent, config);
    self.clientDialogRef.componentInstance.client = client;
    self.clientDialogRef.componentInstance.readOnly = false;

    self.clientDialogRef.afterClosed().subscribe((result: any) => {
      self.clientDialogRef = null;
      if (result) this.f['client'].setValue(result);
    });
  }

  setEditable(value: boolean = false) {
    this.readOnly = value;
  }

  async onSubmit() {
    this.submitted = true;
    let data: IProject = _.cloneDeep(this.form.value);
    if (typeof data.client !== 'string') {
      data.client = data.client?._id;
    }
    data.stakeholders = []
    console.log(data)
    if (this.form.invalid) return;
    this.saving = true;
    data.company = this._AuthService.companyId();

    // validar data presubmit --------------------------------------------------------------------------
    let invalidData = false;
    const expenses: any = this.project.expenses;
    expenses.map((item: any) => {
      if(item.vendor === '') item.vendor = null;
      if (!item.vendor?._id && item.vendor !== null) {
        this._AlertService.warn("Debes seleccionar un proveedor previamente cargado en tu base de datos o dejar el campo vacío");
        invalidData = true;
      }
    })

    if (invalidData) {
      this.saving = false;
      return
    };
    // validar data presubmit --------------------------------------------------------------------------

    data.expenses = this.project.expenses?.map(item => {
      console.log(item)
      let id = item._id
      //console.log(id)
      delete item._id
      return {
        expense: (item.expense?._id as string) || null,
        detail: item.detail || '',
        vendor: (item.vendor?._id as string) || null,
        description: item.description || this.emptyItemExpense.description,
        date: item.date || this.emptyItemExpense.date,
        quantity: item.quantity || this.emptyItemExpense.quantity,
        amount: item.amount || this.emptyItemExpense.amount,
        subtotal: item.subtotal || this.emptyItemExpense.subtotal,
        taxPercentage: item.taxPercentage || this.emptyItemExpense.taxPercentage,
        tax: item.tax || this.emptyItemExpense.tax,
        total: item.total || this.emptyItemExpense.total,
      } as IExpense;
    });
    console.log(data.expenses)


    if (!data.expenses?.length) {
      data.expenses = [this.emptyItemExpense];
    }

    if (this.project._id) {
      data._id = this.project?._id;
      this._ProjectsHttpService.updateProject(data).subscribe({
        next: (project) => {
          this.dialog.close(project);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    } else {
      this._ProjectsHttpService.createProject(data).subscribe({
        next: (project) => {
          this.dialog.close(project);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    }
  }

  cancelSubmit() {
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    this.getProject();
  }

  /*----------------- Expenses ------------------*/
  onListChangeExpenses(event: any) {
    console.log(event);
    this.f['expenses'].setValue(event.items);
    this.f['totalExpenses'].setValue(event.totals.total);
  }
}

function clientValidator(control: AbstractControl): any {
  control.setErrors(null);
  if (control.value) {
    if (!_.get(control.value, '_id')) return { notFound: true };
  }
}
